import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import ReportingComponent from './component';

class Reporting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stats: null,
      topSelling: null,
      tableCount: [0, 1, 2, 3, 4],
      dateFrom: moment().subtract(7, 'd'),
      dateTo: moment(),
      loading: false
    };
  }

  componentDidMount() {
    const { vmId } = this.props.match.params;
    if (!vmId) {
      toastr.error('Error', 'Invalid VM');
      this.props.history.push('/vendingmachines');
    }
    this.setState({
      loading: true
    });
    this.props.getDataFromAPI(
      `/vendingmachines/reporting?dateFrom=${this.state.dateFrom.format(
        'YYYY-MM-DD'
      )}&dateTo=${this.state.dateTo.format('YYYY-MM-DD')}&vmId=${vmId}`,
      'GET',
      undefined,
      response => {
        this.setState({
          stats: response.stats,
          topSelling: response.topSellingItems,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch vending machine stats');
        this.setState({
          loading: false
        });
      }
    );
  }

  handleShowReport = () => {
    const { vmId } = this.props.match.params;
    if (!vmId) {
      toastr.error('Error', 'Invalid VM');
      this.props.history.push('/vendingmachines');
    }
    this.setState({
      loading: true
    });
    this.props.getDataFromAPI(
      `/vendingmachines/reporting?dateFrom=${this.state.dateFrom.format(
        'YYYY-MM-DD'
      )}&dateTo=${this.state.dateTo.format('YYYY-MM-DD')}&vmId=${vmId}`,
      'GET',
      undefined,
      response => {
        this.setState({
          stats: response.stats,
          topSelling: response.topSellingItems,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch vending machine stats');
        this.setState({
          loading: false
        });
      }
    );
  };

  handleFromDateChange = date => {
    this.setState({
      dateFrom: moment(date)
    });
  };

  handleToDateChange = date => {
    this.setState({
      dateTo: moment(date)
    });
  };

  render() {
    console.log(this.state.topSelling);
    return (
      <ReportingComponent
        loading={this.state.loading}
        dateFrom={this.state.dateFrom}
        dateTo={this.state.dateTo}
        changeFrom={this.handleFromDateChange}
        changeTo={this.handleToDateChange}
        stats={this.state.stats}
        topSelling={this.state.topSelling}
        tableCount={this.state.tableCount}
        handleShowReport={this.handleShowReport}
      />
    );
  }
}

export default withRouter(connect(null, { getDataFromAPI })(Reporting));



// WEBPACK FOOTER //
// ./src/Modules/Reporting/container.jsx